// Voice Messaging Types

export type SignalType = 'offer' | 'answer' | 'ice-candidate' | 'voice-message' | 'online-users';

export interface ISignalMessage {
  type: SignalType;
  from: string;
  from_name: string;
  to: string;
  room_id?: string;
  payload: string;
  timestamp: number;
}

export interface IOnlineUser {
  username: string;
  name: string;
  online_since: number;
}

export interface IVoiceMessage {
  id: string;
  from: string;
  from_name: string;
  to: string;
  duration: number;  // seconds
  blob?: Blob;
  audio_url?: string;
  timestamp: number;
}

export interface IStoredVoiceMessage {
  id: string;
  from: string;
  from_name: string;
  to: string;
  audio_base64: string;
  duration: number;
  created_at: number;
  expires_at: number;
  time_remaining: string;  // "23h 45m remaining"
  played: boolean;
}

export interface IVoiceMessageRequest {
  to: string;
  audio_base64: string;
  duration: number;
}

export interface IPendingCountResponse {
  total: number;
  unplayed: number;
}

export type CallState = 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error';

export type ConnectionState = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

export interface IWebRTCState {
  isConnected: boolean;
  connectionState: ConnectionState;
  onlineUsers: IOnlineUser[];
  pendingMessages: IStoredVoiceMessage[];
  pendingCount: number;
  unplayedCount: number;
}

// WebRTC configuration
export const RTC_CONFIG: RTCConfiguration = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },
  ],
};

// Voice message constraints
export const VOICE_MESSAGE_CONSTRAINTS = {
  maxDuration: 60,        // seconds
  maxSizeBytes: 1024 * 1024,  // 1MB
  maxMessagesPerUser: 50,
  retentionHours: 24,
};
